module.exports = __webpack_public_path__ + "media/brands/longjia-f3ce8db2.png";